import { defineComponent as _defineComponent } from 'vue'
import { toRefs } from "@nuxtjs/composition-api";
import { useMobile } from "~/core/composables/useMobile";
import { Purchase } from "~/core/types/purchase-popup-2/Purchase";
import MunicipalityTx from "~/core/models/purchase-popup-2/MunicipalityTx";
import Web3MunicipalityTx from "~/core/models/purchase-popup-2/Web3MunicipalityTx";

interface Props {
    purchase: Purchase;
    transactionObject: MunicipalityTx | Web3MunicipalityTx,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PapPurchaseSummary',
  props: {
    purchase: null,
    transactionObject: null
  },
  emits: ['onClickBack', 'onStartLoading', 'onStopLoading', 'onSuccessFullPayment'],
  setup(__props: any, { emit: $emit }) {

const props = __props as { purchase: Purchase, transactionObject: MunicipalityTx | Web3MunicipalityTx };





const {
    purchase,
    transactionObject,
} = toRefs(props);

const isMobile = useMobile();

const handlePay = async () => {
    try {
        $emit('onStartLoading');
        await transactionObject.value.sendPAP();
        $emit('onSuccessFullPayment');
        $emit('onStopLoading');
    } catch (e) {
        $emit('onStopLoading', e);
    }
}

return { __sfc: true,props, $emit, purchase, transactionObject, isMobile, handlePay }
}

})